import { ArtstuffAclModule } from '@aes/acl';
import { NgModule } from '@angular/core';
import { LoginModule } from './login/login.module';
import { ChangePasswordModule } from "./change-password/change-password.module";

const PROVIDERS = [];

@NgModule({
  imports: [LoginModule, ArtstuffAclModule, ChangePasswordModule],
  providers: PROVIDERS,
})
export class AuthModule {}
